export interface ClanConfig {
  id: string; // Оставляем string для удобства, но значения будут цифрами
  name: string;
  emoji: string;
  description: string;
  gradient: string;
  auraColor: string;
}

export const CLANS: ClanConfig[] = [
  {
    id: '1', // Было 'shark'
    name: 'Акула',
    emoji: '🦈',
    description: 'Действуй быстро, бери своё.',
    gradient: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
    auraColor: '#00d2ff',
  },
  {
    id: '2', // Было 'elephant'
    name: 'Слон',
    emoji: '🐘',
    description: 'Сила в спокойствии.',
    gradient: 'linear-gradient(135deg, #ff9966, #ff5e62)',
    auraColor: '#ff9966',
  },
  {
    id: '3', // Было 'gorilla'
    name: 'Горилла',
    emoji: '🦍',
    description: 'Тихая сила.',
    gradient: 'linear-gradient(135deg, #134E5E, #71B280)',
    auraColor: '#71B280',
  },
  {
    id: '4', // Было 'wolf'
    name: 'Волк',
    emoji: '🐺',
    description: 'Вместе мы — неизбежность.',
    gradient: 'linear-gradient(135deg, #232526, #414345)',
    auraColor: '#a8a9ad',
  },
];